import StyledNavSubListItem from './style';

const NavSubListItem = ({ children, handleClose, className }) => (
  <StyledNavSubListItem className={className} disableGutters disableRipple onClick={handleClose}>
    {children}
  </StyledNavSubListItem>
);

export default NavSubListItem;
